/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, July 31st 2026, 9:35:48 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { getFormConfiguration } from "lib/factories";
import { FormConfiguration } from "lib/schemas";
import { useServiceBuilderContext } from "service-builder/providers";

export const useOnAPICreateSubmissionForm = () => {
  const {
    processDefinitionContext: { currentProcessDefinition },
    updateTemplateArtifactsOnAPISaveFormConfiguration,
  } = useServiceBuilderContext();

  const onSaveFormInfo = React.useCallback(
    (updatedFormConfig: FormConfiguration, callBack?: () => void) => {
      updateTemplateArtifactsOnAPISaveFormConfiguration(updatedFormConfig, "application_form", (processDef) =>
        callBack?.()
      ); // Update the form type on the artifact as per the form type selected in the props, since the may need to treat the form differently from its actual form type.
    },
    [updateTemplateArtifactsOnAPISaveFormConfiguration]
  );

  const defaultNewFormConfiguration = getFormConfiguration(currentProcessDefinition.artifact_org, {
    form_type: "application_form",
    title: "",
    login_required: true,
    sites: [currentProcessDefinition.site],
    entry_number_default_prefix: currentProcessDefinition.service_code,
  });

  return { onSaveFormInfo, defaultNewFormConfiguration };
};
